import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: 'wander-e4f0d.firebaseapp.com',
  projectId: 'wander-e4f0d',
  storageBucket: 'wander-e4f0d.appspot.com',
  messagingSenderId: '930668014304',
  appId: '1:930668014304:web:2582f667b0cf844b0a3e85',
  measurementId: 'G-SR6VJ4M943',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth();
export const db = getFirestore(app);
export const functions = getFunctions(app);

// Route Places gateway calls (searchPlaces/getPlaceDetails/getPlacePhoto) to a
// local `firebase emulators:start --only functions` in dev, instead of the
// real (currently undeployed) Cloud Functions. Auth stays on production —
// only Functions traffic is redirected — so normal login still works.
if (process.env.NODE_ENV === 'development') {
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
}

// `yarn start:local` runs Auth, Firestore and Functions emulators together and sets this flag,
// so sign-ups, trips and account deletion can be tried without touching the real project.
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_USE_EMULATORS === 'true') {
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
}
